<template>
    <DForm @submit.prevent="submitForm">
        <DFormRow
            :label="__('settings.newsletter_settings.form.api_key')"
            :is-required="true"
            :error="errorsData.api_key"
            :hint="__('settings.newsletter_settings.form.api_key_hint')"
        >
            <DInput
                id="api_key"
                v-model="form.api_key"
                :placeholder="__('settings.newsletter_settings.form.api_key')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('api_key')"
                maxlength="255"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.newsletter_settings.form.enable_actions')"
            :is-required="true"
            :hint="__('settings.newsletter_settings.form.enable_actions_hint')"
        >
            <DSwitch
                v-model="form.enable_actions"
                color="success"
                variant="3d"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.newsletter_settings.form.double_opt_in_enabled.label')"
            :error="errorsData.double_opt_in_enabled"
            :hint="__('settings.newsletter_settings.form.double_opt_in_enabled.description')"
        >
            <DFormCheck
                id="double_opt_in"
                v-model="form.double_opt_in_enabled"
                inline
                :is-valid="isFormFieldValid('double_opt_in_enabled')"
            />
        </DFormRow>
        <DFormRow
            :label="__('settings.newsletter_settings.form.newsletter_active.label')"
            :hint="__('settings.newsletter_settings.form.newsletter_active.description')"
            :error="errorsData.newsletter_active"
        >
            <DInput
                id="newsletter_active"
                v-model="form.newsletter_active"
                type="number"
                :placeholder="__('settings.newsletter_settings.form.newsletter_active.label')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('newsletter_active')"
                max="127"
            />
        </DFormRow>
        <DFormRow
            v-if="form.double_opt_in_enabled"
            :label="__('settings.newsletter_settings.form.double_opt_in_request.label')"
            :hint="__('settings.newsletter_settings.form.double_opt_in_request.description')"
            :error="errorsData.double_opt_in_request"
        >
            <DInput
                id="double_opt_in_request"
                v-model="form.double_opt_in_request"
                type="number"
                :placeholder="__('settings.newsletter_settings.form.double_opt_in_request.label')"
                add-input-classes="bg-light"
                :is-valid="isFormFieldValid('double_opt_in_request')"
                max="127"
            />
        </DFormRow>
        <DRow>
            <DCol sm="4" />
            <DCol sm="4">
                <div
                    v-if="connectionStatus === 'successful'"
                    class="green-text"
                >
                    {{ __('settings.newsletter_settings.connection_successful') }}
                </div>
                <div
                    v-if="connectionStatus === 'unsuccessful'"
                    class="red-text"
                >
                    {{ __('settings.newsletter_settings.connection_unsuccessful') }}
                </div>
            </DCol>
            <DCol
                sm="4"
                class="check-database-connection-btn"
            >
                <DButton
                    icon="lan-connect"
                    :label="__('settings.newsletter_settings.check_connection')"
                    :disabled="isInLoadingState"
                    @click="checkConnection"
                />
            </DCol>
        </DRow>
        <DFormControls
            v-show="credentialsValid"
            :dirty="form.isDirty"
            @submit="submitForm"
        />
        <DConnectionErrorModal
            :show-modal="connectionException !== null"
            :exception="connectionException"
            @close-modal="closeErrorCheckModal"
        />
    </DForm>
</template>

<script>

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

export default {
    name: 'NewsletterSettingsForm',
    components: { DConnectionErrorModal },
    props: {
        newsletterSettings: {
            type: Object,
            default: () => { return {} }
        },
        errors: {
            type: Object,
            default: () => { return {} }
        }
    },
    emits: ['form-submitted'],
    data () {
        return {
            form: this.$inertia.form({
                api_key: this.newsletterSettings?.api_key ?? null,
                enable_actions: this.newsletterSettings?.enable_actions ?? false,
                double_opt_in_enabled: this.newsletterSettings?.double_opt_in_enabled ?? false,
                newsletter_active: this.newsletterSettings?.newsletter_active ?? null,
                double_opt_in_request: this.newsletterSettings?.double_opt_in_request ?? null
            }),
            connectionStatus: '',
            credentialsValid: false,
            connectionException: null,
            error: null,
            errorsData: this.errors
        }
    },
    watch: {
        form: {
            handler: function () {
                this.connectionStatus = ''
                this.credentialsValid = false
            },
            deep: true
        }
    },
    methods: {
        submitForm () {
            this.$emit('form-submitted', this.form)
        },
        checkConnection () {
            this.errorsData = {}
            const self = this
            self.connectionException = null
            window.axios.post(this.$route('settings.newsletter-settings.check', this.form))
                .then(function () {
                    self.connectionStatus = 'successful'
                    self.credentialsValid = true
                })
                .catch(function (error) {
                    self.connectionStatus = 'unsuccessful'
                    self.credentialsValid = false
                    if (error.response.data.error !== undefined) {
                        self.error = error.response.data.error
                    }
                    if (error.response.data.errors !== undefined) {
                        self.errorsData = error.response.data.errors

                        for (const key in self.errorsData) {
                            if (typeof self.errorsData[key] === 'object') {
                                self.errorsData[key] = self.errorsData[key][0]
                            }
                        }
                    }
                    if (error?.response.data.exception !== undefined) {
                        self.connectionException = error?.response.data.exception
                    }
                })
        },
        closeErrorCheckModal () {
            this.connectionException = null
            this.error = null
        }
    }
}
</script>

<style lang="scss" scoped>
.check-database-connection-btn {
    text-align: right;
    padding-bottom: 25px;
}
.green-text {
    color: green;
}
.red-text {
    color: red;
}
</style>
